var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ListService, Pager } from './list.service';
var RowsComponent = /** @class */ (function (_super) {
    __extends(RowsComponent, _super);
    function RowsComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.pager = new Pager();
        _this.recs_for_pages = [10, 20, 50, 100];
        _this.options = [];
        _this.events = { rows: 'rows' };
        _this.clickable = true;
        return _this;
    }
    RowsComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.options = [];
        for (var _i = 0, _a = this.recs_for_pages; _i < _a.length; _i++) {
            var r = _a[_i];
            this.options.push({ code: r, display: r.toString() });
        }
        var params = this.component.params || {};
        this.groupName = this.service.getGroupName(params.groupName);
        this.saveQuery = this.service.setSaveQuery(this.groupName, params.saveQuery);
        this.clickable = this.action.validEvent(this.events.rows);
        var limit = 10;
        var cond = this.service.getCondition(this.groupName);
        if (typeof cond !== 'undefined' && this.saveQuery) {
            limit = cond.limit;
        }
        else {
            limit = (params.initQuery && typeof params.initQuery.limit !== 'undefined' ? params.initQuery.limit : this.options[0].code);
        }
        this.pager.count_per_page = limit;
        this.service.getQuery({ limit: limit }, this.groupName);
    };
    RowsComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    RowsComponent.prototype.onSubscribe = function (data) {
        this.pager = new Pager();
        if (typeof data !== 'undefined') {
            var query = this.service.getCurrentQuery(this.groupName);
            this.pager.count_per_page = query.limit;
        }
    };
    RowsComponent.prototype.onEvent = function (e1, e2, rec) {
        if (e2 === 'rows') {
            this.service.setBulkClear(this.groupName, false);
            this.service.getQuery({ limit: rec, page: 1 }, this.groupName);
            this.action.firstAction(this.events[e2], { queryGroupName: this.groupName });
        }
    };
    RowsComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'rows',
                    template: "<p class=\"-note\" id=\"{{ componentName }}\">\n  {{ (msg | async)['ListComponent.label.rows'] }}\n  <column-select [col]=\"{required: true, disabled: !clickable, params: {options: options}}\" [val]=\"pager.count_per_page\" [msg]=\"(msg | async)\" (changeVal)=\"onEvent('', 'rows', $event.val)\"></column-select>\n</p>\n"
                }] }
    ];
    /** @nocollapse */
    RowsComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ListService }
    ]; };
    return RowsComponent;
}(ContentBaseComponent));
export { RowsComponent };
//# sourceMappingURL=rows.component.js.map